// =============================================================================
// HUB FINANCE - Dashboard CFO (CC-25b — version "grille de widgets")
// =============================================================================
// Le contenu historique de ce dashboard a été extrait en 6 widgets dans
// frontend/src/widgets/finance/, eux-mêmes catalogués côté serveur
// (backend/dashboard/catalog.py) et résolus via la cascade dashboard_layouts.
//
// JJ ou Stéphanie peuvent activer/désactiver et réordonner chaque widget
// depuis le mode Édition (bouton Pencil → Bibliothèque).
//
// L'ancien rendu monolithique reste accessible dans l'historique git
// (commit antérieur à CC-25b L4 Finance).
// =============================================================================
import DashboardGrid from "../../components/dashboard/DashboardGrid";

export default function DashboardFinance({ tenantId, onNavigate }) {
  // tenantId est lu en interne par les widgets via localStorage.user
  // (cf. widgets/finance/useFinanceFetch.js). onNavigate sera wiré en V2
  // quand les widgets supporteront des actions navigateables.
  return (
    <DashboardGrid hub="finance" title="Dashboard Finance" />
  );
}
